module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.488ce034.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }